<script>
export default {
  name: "auction-timer",
  data: function() {
    return {
      startTimeMilliseconds: "",
      timerInterval: "",
      fractionRemaining: 1,
      FULL_DASH_ARRAY: 283,
      timePassed: 0,
      timeLeft: this.duration,
      timerInterval: null,
      remainingPathColor: "green",
      hasStarted: false,
      extend: 0,
      hasExtended: false,
    };
  },
  methods: {
    formatTime: function(time) {
      return formatTime(time);
    },
    onTimesUp: function() {
      clearInterval(this.timerInterval);
    },
    startTimer: function() {
      var self = this;
      if (self.timePassed < self.duration && self.auctionStatus != "Complete") {
        self.timerInterval = setInterval(() => {
          self.timePassed = self.timePassed += 0.25;
          self.$store.commit("setTimePassed", self.timePassed);
          self.timeLeft = self.timePassed < 0 ? self.duration : self.duration - self.timePassed;
          self.setCircleDashArray();

          if (self.timeLeft === 0) {
            self.onTimesUp();
          }
          if (self.timePassed >= self.duration) {
            self.onTimesUp();
          }
        }, 250);
      } else {
        self.timeLeft = 0;
      }
    },
    calculateTimeFraction: function() {
      const rawTimeFraction = this.timeLeft / this.duration;
      return rawTimeFraction - (1 / this.duration) * (1 - rawTimeFraction);
    },
    setCircleDashArray: function() {
      if (this.auctionStatus != "Unstarted") {
        const circleDasharray = `${(this.calculateTimeFraction() * this.FULL_DASH_ARRAY).toFixed(0)} 283`;
        this.$refs.baseCircle.setAttribute("stroke-dasharray", circleDasharray);
      }
    },
    setTimePassed: function() {
      var start = this.startTime;
      var now = new Date();
      this.timePassed = (now - start) / 1000;
      this.$store.commit("setTimePassed", this.timePassed);
    },
    onExtended: function(seconds) {
      this.timeLeft = this.timePassed < 0 ? this.duration : this.duration - this.timePassed;
      this.setCircleDashArray();
      if (seconds == 30) {
        this.extend = "+30 sec.";
      } else {
        this.extend = "+2 min.";
      }
      this.hasExtended = true;
      var self = this;
      setTimeout(function() {
        self.hasExtended = false;
      }, 400);
    },
    leave: function(el, done) {
      Velocity(el, { translateY: "-60px", opacity: "0" }, { duration: 1000 }, { complete: done });
    },
    enter: function(el, done) {
      Velocity(el, { opacity: 1, fontSize: "14px", translateY: "-20px" }, { duration: 600 });
    },
  },
  computed: {
    auction: function() {
      return this.$store.state.activeAuction;
    },
    auctionId: function() {
      return this.$store.state.activeAuction.id;
    },
    auctionStatus: function() {
      return this.$store.state.activeAuction.status;
    },
    auctionEndDate: function() {
      return this.$store.state.activeAuction.auctionEnd;
    },
    formatTimeLeft: function(time) {
      return formatTime(time);
    },
    circleColourClass: function() {
      if (this.timeLeft / this.duration > 0.25) {
        return "standard-colour";
      } else if (this.timeLeft / this.duration > 0.125) {
        return "alert-colour";
      } else {
        return "warning-colour";
      }
    },
    textColorClass: function() {
      if (this.timeLeft <= 10 && this.timeLeft > 0) {
        return "warning-colour blinking";
      } else {
        return "";
      }
    },
    formatDate: function() {
      return formatDate(this.startTime, true, true);
    },
    notActive: function() {
      return (this.timePassed <= 0 && this.timeLeft == this.duration) || this.timePassed >= this.duration;
    },
    extend30: function() {
      return this.$store.state.auctionExtended30;
    },
    extend2min: function() {
      return this.$store.state.auctionExtended2min;
    },
    startTime: function() {
      return new Date(this.$store.state.activeAuction.auctionStart);
    },
    duration: function() {
      return this.$store.state.activeAuction.duration * 60;
    },
  },
  mounted: function() {
    this.setTimePassed();
    this.startTimer();
  },
  watch: {
    auction: {
      handler: function(val) {
        if (val.status == "Complete") {
          this.timeLeft = 0;
          this.onTimesUp();
        } else {
          clearInterval(this.timerInterval);
          this.setTimePassed();
          this.startTimer();
        }
      },
      deep: true,
    },
    extend30: function() {
      this.onExtended(30);
    },
    extend2min: function() {
      this.onExtended(120);
    },
  },
  destroyed: function() {
    this.onTimesUp();
  },
};
</script>
<template>
  <div class="base-timer" v-if="auctionStatus != 'Unstarted'">
    <svg class="base-timer__svg" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
      <g class="base-timer__circle">
        <circle class="base-timer__path-elapsed" cx="50" cy="50" r="45" />
        <path
          ref="baseCircle"
          stroke-dasharray="283"
          :class="`base-timer__path-remaining ${circleColourClass}`"
          d="
          M 50, 50
          m -45, 0
          a 45,45 0 1,0 90,0
          a 45,45 0 1,0 -90,0
        "
        ></path>
      </g>
    </svg>
    <span id="base-timer-label" class="base-timer__label" :class="textColorClass">
      {{ formatTime(timeLeft) }}
    </span>
    <transition v-bind:css="false" v-on:leave="leave" v-on:enter="enter">
      <div class="extend-wrapper" v-if="hasExtended">{{ extend }}</div>
    </transition>
  </div>
</template>
<style scoped>
body {
  font-family: sans-serif;
  display: grid;
  height: 100vh;
  place-items: center;
}

.base-timer {
  position: relative;
  width: 60px;
  height: 60px;
  text-align: center;
  position: -webkit-sticky; /* Safari & IE */
  position: sticky;
  top: 0;
}

.base-timer__svg {
  transform: scaleX(-1);
}

.base-timer__circle {
  fill: none;
  stroke: none;
}

.base-timer__path-elapsed {
  stroke-width: 7px;
  stroke: grey;
}

.base-timer__path-remaining {
  stroke-width: 7px;
  stroke-linecap: round;
  transform: rotate(90deg);
  transform-origin: center;
  transition: 1s linear all;
  fill-rule: nonzero;
  stroke: currentColor;
}

.base-timer__path-remaining.green {
  color: rgb(65, 184, 131);
}

.alert-colour {
  color: orange;
}

.warning-colour {
  color: red;
}
.standard-colour {
  color: #608ebd;
}

.base-timer__label {
  position: absolute;
  width: 60px;
  height: 60px;
  top: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
}
.extend-wrapper {
  position: absolute;
  width: 60px;
  height: 60px;
  top: 0;
  align-items: center;
  justify-content: center;
  color: green;
  font-size: 36px;
  word-break: break-all;
  white-space: nowrap;
  text-align: center;
}
.blinking {
  animation: blinker 1s linear infinite;
}

@keyframes blinker {
  50% {
    opacity: 0;
  }
}
.timer-message {
  white-space: nowrap;
  text-align: center;
  margin-left: calc(-60px - 37.5px);
  display: inline-block;
  width: 260px;
}
.timer-message > i {
  font-size: 12px;
}

@keyframes bounce-in {
  0% {
    transform: scale(0);
  }
  50% {
    transform: scale(1.5);
  }
  100% {
    transform: scale(1);
  }
}
@keyframes fade-up {
  0% {
    transform: translateY(0);
    opacity: 1;
  }
  50% {
    transform: translateY(25);
    opacity: 0.5;
  }
  100% {
    transform: translateY(50);
    opacity: 0;
  }
}
</style>
